module.exports = __webpack_public_path__ + "img/spotify-mobile.f518e67f.png";